import { useAccount } from '../api/getAccount';

import { can } from './can';

export function usePermissions() {
  const { data } = useAccount();

  // Legacy fallback only when the ACL list is missing (old backends send no
  // field or null, or the account is still loading). An explicit empty array
  // means "no permissions" — do not open the app.
  const permissions = data?.permissions;
  if (!Array.isArray(permissions)) {
    return { can: () => true };
  }

  return { can: (key: string) => can(permissions, key) };
}
